export const isToolbarEnabled = true;
export const showTitleInMobileMode = true;